import React from 'react'

const LandingLinks = ({className, H1, links}) => (
  <div className='land-links'>
    <div className={className}>
      {H1}

      <div>
        {links.map((e, i) => (
          <a
            key={className + i}
            href={e.url ?? '/'}
            target='_blank' rel='noopener noreferrer'
          >
            <div style={{backgroundImage: `url("${e.logoUrl}")`}}/>
          </a>
        ))}
      </div>
    </div>
  </div>
)

export default LandingLinks
